import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-26eb18e3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "approve_form container-lg container-fluid" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "text-primary" }, "Approve health priority need", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_ApproveHealthNeed = _resolveComponent("ApproveHealthNeed")!
  const _component_TermsAndConditions = _resolveComponent("TermsAndConditions")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.layout === true)
      ? (_openBlock(), _createBlock(_component_Header, {
          key: 0,
          class: "mb-5 pb-4"
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("section", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("p", null, [
          _createTextVNode(" The health need below was submitted for your approval, please read the "),
          _createElementVNode("span", {
            class: "text-primary cursor-pointer",
            to: "terms",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.termsModal = true))
          }, "Terms and Conditions"),
          _createTextVNode(" before approval ")
        ])
      ]),
      _createVNode(_component_ApproveHealthNeed)
    ]),
    _createVNode(_component_Dialog, {
      visible: _ctx.termsModal,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.termsModal) = $event)),
      style: { width: '50rem' },
      breakpoints: { '600px': '85vw' },
      modal: true,
      header: " ",
      class: "hide_cloe",
      dismissableMask: true
    }, {
      default: _withCtx(() => [
        _createVNode(_component_TermsAndConditions)
      ]),
      _: 1
    }, 8, ["visible"]),
    (_ctx.layout === true)
      ? (_openBlock(), _createBlock(_component_Footer, { key: 1 }))
      : _createCommentVNode("", true)
  ], 64))
}